/**
 * Domain service for evaluating survey status and availability
 */
export class SurveyStatusEvaluator {
  /**
   * Checks if a survey is available for submission
   */
  static isAvailableForSubmission(
    isActive: boolean | undefined,
    hasAlreadyAnswered: boolean
  ): boolean {
    return !!isActive && !hasAlreadyAnswered;
  }

  /**
   * Gets the reason why a survey is unavailable
   */
  static getUnavailableReason(
    isActive: boolean | undefined,
    hasAlreadyAnswered: boolean
  ): 'already-answered' | 'inactive' | null {
    if (hasAlreadyAnswered) {
      return 'already-answered';
    }
    if (!isActive) {
      return 'inactive';
    }
    return null;
  }
}
